// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyVisualModeFromStorage } from './utils/visualMode';
import { VisualModeProvider } from './context/VisualModeContext'; // 👈 lisää tämä

// Hiljennä turhat konsolilokit tuotannossa (jätä warn/error näkyviin).
// Voit ohittaa hiljennyksen asettamalla REACT_APP_DEBUG_LOGS=1 build-ympäristöön.
/* eslint-disable no-console */
if (
  process.env.NODE_ENV === 'production' &&
  String(process.env.REACT_APP_DEBUG_LOGS || '').trim() !== '1'
) {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.trace = noop;
  // usein kirjastot käyttävät myös näitä:
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
  console.time = noop;
  console.timeEnd = noop;
}
/* eslint-enable no-console */

// Lue talteen edellinen visuaalinen tila (full / minimal) heti käynnistyksessä
applyVisualModeFromStorage();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <VisualModeProvider>
    <App />
    </VisualModeProvider>
  </React.StrictMode>
);

// Web Vitals: ei logiteta tuotannossa. Jos haluat mitat kehityksessä konsoliin,
// poista kommentti alla olevasta rivistä.
// if (process.env.NODE_ENV !== 'production') reportWebVitals(console.log);

reportWebVitals();
